export const PrintAgreementVersionPeriodLinesOptions = {
    ShowAllAvailablePricesAndSurcharges: '1',
    ShowAllAvailablePricesAndSurchargesExceptEnergySurcharge: '2',
    ShowFreightPricesWithoutSurcharge: '3'
};